import { createContext, useContext, useEffect, useState } from "react";
import { api } from "./apiClient";
import { useAuth } from "./AuthContext";

const MatchContext = createContext(null);
const LS_KEY = "mc_selected_match_id";

export function MatchProvider({ children }) {
  const { user } = useAuth();
  const [matches, setMatches] = useState([]);
  const [selectedMatchId, setSelectedMatchId] = useState(null);
  const [loaded, setLoaded] = useState(false);

  const refresh = async () => {
    if (!user) { setMatches([]); setSelectedMatchId(null); setLoaded(true); return; }
    try {
      const { data } = await api.get("/matches");
      setMatches(data);
      const saved = localStorage.getItem(LS_KEY);
      const allowedIds = data.map((m) => m.id);
      let next = null;
      if (saved && allowedIds.includes(saved)) next = saved;
      else if (data.length === 1) next = data[0].id;
      setSelectedMatchId(next);
      if (next) localStorage.setItem(LS_KEY, next); else localStorage.removeItem(LS_KEY);
    } catch {
      setMatches([]);
      setSelectedMatchId(null);
    } finally {
      setLoaded(true);
    }
  };

  useEffect(() => {
    setLoaded(false);
    refresh();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [user?.id]);

  const chooseMatch = (id) => {
    setSelectedMatchId(id);
    if (id) localStorage.setItem(LS_KEY, id); else localStorage.removeItem(LS_KEY);
  };

  const selectedMatch = matches.find((m) => m.id === selectedMatchId) || null;

  return (
    <MatchContext.Provider value={{ matches, selectedMatchId, selectedMatch, chooseMatch, refresh, loaded }}>
      {children}
    </MatchContext.Provider>
  );
}

export function useMatch() {
  return useContext(MatchContext);
}
